import { IconFn, IconSvg } from "../createIcon";

export const ArrowIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 48, height: 48 }} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.1384 3.05839C25.2162 1.98054 26.9638 1.98054 28.0416 3.05839L46.4416 21.4584C47.5195 22.5362 47.5195 24.2838 46.4416 25.3616L28.0416 43.7616C26.9638 44.8395 25.2162 44.8395 24.1384 43.7616C23.0605 42.6838 23.0605 40.9362 24.1384 39.8584L40.5868 23.41L24.1384 6.96161C23.0605 5.88377 23.0605 4.13623 24.1384 3.05839ZM1.25 23.41C1.25 21.8857 2.48569 20.65 4.01 20.65H28.5433C30.0676 20.65 31.3033 21.8857 31.3033 23.41C31.3033 24.9343 30.0676 26.17 28.5433 26.17H4.01C2.48569 26.17 1.25 24.9343 1.25 23.41Z"
      fill={color}
    />
  </IconSvg>
);
